<template>
  <v-container
    fluid
    class="pt-2 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout class="business-details-container">
      <v-flex xs6 class="mr-1">
        <v-card class="mb-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>fa-coins</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Company Details</h4>
            </div>
          </v-card-title>
          <v-card flat>
            <v-card-text class="py-0">
              <v-container grid-list-md class="pb-0">
                <v-form lazy-validation>
                  <v-layout wrap>
                    <v-flex xs6>
                      <img :src="business.logo" alt="Logo" class="responsive" />
                    </v-flex>
                    <v-flex xs6>
                      <image-edit-upload :url.sync="business.logo" :path="'funder-images'"></image-edit-upload>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs8>
                      <v-text-field
                        :disabled="business.api_connection_enabled"
                        label="Company Name"
                        v-model="business.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <abf-date-picker label="Last Reviewed" v-model="business.last_reviewed_at" />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-title class="pb-0 pt-2">
              <v-avatar class="secondary">
                <v-icon dark>business</v-icon>
              </v-avatar>
              <div class="ml-3">
                <h4 class="headline">Registered Company Details</h4>
              </div>
            </v-card-title>
            <v-card-text class="py-0">
              <v-container grid-list-md class="pt-0">
                <span class="ml-4 pl-3 d-block">
                  Applied across all products unless set differently on individual products
                </span>
                <v-form lazy-validation>
                  <v-layout wrap>
                    <v-flex xs4>
                      <v-text-field
                        label="Registered Company Name"
                        v-model="business.registered_company_name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Registered Company Number"
                        v-model="business.registered_company_number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field label="CFX ENT Number" v-model="business.job_code"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-title class="pb-0 pt-2">
              <v-avatar class="secondary">
                <v-icon dark>fal fa-user-secret</v-icon>
              </v-avatar>
              <div class="ml-3">
                <h4 class="headline">Invisible Funder</h4>
              </div>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-container grid-list-md class="pt-0">
                <span class="ml-4 pl-3 d-block">Determines if a Funder's products are displayed to the SME</span>
                <v-form lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-switch v-model="business.invisible_provider" label="Invisible Funder"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-card>
      </v-flex>

      <v-flex xs6 class="ml-1">
        <v-card class="mb-2">
          <v-card-title class="pb-0">
            <v-avatar class="secondary">
              <v-icon dark>mail</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Communications</h4>
            </div>
          </v-card-title>
          <v-card flat>
            <v-card-text class="pt-0">
              <v-container grid-list-md class="pt-0">
                <span class="ml-4 pl-3 d-block"
                  >Prevent referral emails and/or enquiry emails being sent for this Funder</span
                >
                <v-form lazy-validation>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-switch v-model="business.referral_message" label="Send Referral Email"></v-switch>
                    </v-flex>
                    <v-flex xs6>
                      <v-switch v-model="business.suppress_comms" label="Suppress Enquiry Comms"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-card>

        <v-card class="mb-2">
          <v-card-title class="pb-0">
            <v-avatar class="secondary">
              <v-icon dark>fa-people-carry</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Referral Terms</h4>
            </div>
          </v-card-title>
          <v-card flat>
            <v-card-text class="pt-0">
              <v-container grid-list-md class="pt-0">
                <span class="ml-4 pl-3 d-block"
                  >Determines if Designated Bank referrals see this Funder's Products and if Referral Credit is
                  paid</span
                >
                <v-form lazy-validation>
                  <v-layout wrap>
                    <v-flex xs8 lg5>
                      <v-select
                        :items="terms"
                        item-text="name"
                        item-value="id"
                        v-model="business.terms"
                        hide-selected
                        placeholder="Assign BBB Provider Term"
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex xs4 lg3>
                      <v-text-field label="BBB reference" v-model="business.bbb_id" :rules="bbbRefRules"></v-text-field>
                    </v-flex>
                    <v-flex xs4 lg3>
                      <v-text-field
                        label="Referral Commission (%)"
                        v-model="business.referral_commission_percentage"
                        :rules="referralCommissionRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 lg4>
                      <v-switch v-model="business.referral_credit_paid" label="Pay Referral Credit"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-card>

        <v-card class="mb-2">
          <v-card-title class="pb-0">
            <v-avatar class="secondary">
              <v-icon dark>fas fa-plug</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">API Details</h4>
            </div>
          </v-card-title>
          <v-card flat>
            <v-card-text class="pt-0">
              <v-container grid-list-md class="pt-0">
                <span class="ml-4 pl-3 d-block">
                  Enabling this on without the necessary integration code in place will prevent this Funder receiving
                  Enquiries<br />
                  To connect products to the API make sure 'Auto Accept Enquiries' is enabled in the Product Details
                  page<br />
                  <strong
                    >Changing the company name after the API integration has been set up will require code changes and
                    will stop the API working</strong
                  >
                </span>
                <v-form lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-switch v-model="business.api_connection_enabled" label="API Connection Enabled"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-card>

        <v-card class="mb-2">
          <v-card-actions>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-right">
                  <v-btn color="accent" @click="updateBusinessDetails()">Update Business Details</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';
import ImageEditUpload from '../../Partners/ImageEditUpload';
import AbfDatePicker from '@/components/Abf/AbfDatePicker';

export default {
  components: {
    AbfDatePicker,
    ImageEditUpload
  },
  props: ['selectedProduct'],
  data: () => ({
    terms: ['Standard Terms - all referrals', 'No DB referrals', 'Standard Terms - DB referrals only'],
    business: {
      name: null,
      logo: null,
      registered_company_name: null,
      registered_company_number: null,
      terms: null,
      referral_message: null,
      referral_commission_percentage: null,
      suppress_comms: null,
      invisible_provider: null,
      api_connection_enabled: null,
      last_reviewed_at: null
    }
  }),
  name: 'business-details',
  computed: {
    bbbRefRules() {
      return this.business.terms !== 'No DB referrals' ? [v => !!v || 'The BBB ref is required'] : [];
    },
    referralCommissionRules() {
      return [v => Number(v) >= 0 || 'Commission value must be a number'];
    }
  },
  methods: {
    ...mapActions(['updateFunderBusiness']),
    clearBusiness() {
      this.business = {
        name: null,
        logo: null,
        registered_company_name: null,
        registered_company_number: null,
        terms: null,
        referral_message: null,
        referral_commission_percentage: null,
        suppress_comms: null,
        invisible_provider: null,
        last_reviewed_at: null
      };
    },
    updateBusinessDetails() {
      const updates = this.diff(this.business, this.selectedProduct.provider);
      _.unset(updates, 'api');
      this.updateFunderBusiness({ id: this.business.id, updates });
    },
    diff(object, base) {
      function changes(object, base) {
        return _.transform(object, (result, value, key) => {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }
      return changes(object, base);
    }
  },
  mounted() {
    _.merge(this.business, this.selectedProduct.provider);
  },
  watch: {
    selectedProduct: function() {
      this.clearBusiness();
      _.merge(this.business, this.selectedProduct.provider);
    }
  }
};
</script>

<style lang="scss" scoped>
.business-details-container {
  height: calc(100vh - 120px);
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

::v-deep .input-group input:disabled {
  color: rgba(0, 0, 0, 0.87);
}
.responsive {
  max-width: 100%;
}
</style>
